/* global femcare */

femcare.share.socialShare = {
    socialShareElements: document.querySelectorAll('.social--share'),

    /**
     * Initializes the social share functionality.
     */
    init: function () {
        if (this.socialShareElements) {
            this.socialShareElements.forEach((socialShare) => {
                this.initNativeMobileShare(socialShare);
                this.initCopyButton(socialShare);
            });
        }
    },

    /**
     * Sets up the native sharing on the "social__mobile" button.
     * @param {Element} socialShare The social share element to initialize.
     */
    initNativeMobileShare: function (socialShare) {
        const mobileShareButton = socialShare.querySelector('.social__mobile');

        if (mobileShareButton && navigator.share) {
            mobileShareButton.addEventListener('click', () => {
                navigator.share({
                    url: window.location.href,
                    title: document.title
                });
            });
        }
    },

    /**
     * Sets up the functionality to copy the current URL to the clipboard.
     * @param {Element} socialShare The social share element to initialize.
     */
    initCopyButton: function (socialShare) {
        const copyButton = socialShare.querySelector('.social__link--copy');

        if (copyButton) {
            copyButton.addEventListener('click', () => {
                navigator.clipboard.writeText(window.location.href);
            });
        }
    }
};
